import React, { Component } from 'react';
import { Flex, Toast, Modal } from 'antd-mobile';
import Util from 'utils';
import './index.less';
import ImgWrap from '../ImgWrap';

export default class ProductListTransverse extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {}

  goDetail = (item, applyType, value, fromSource) => {
    const { id, type } = item;
    const card = this.setType(value);
    const newItem = {
      value: item
    };
    window.app.routerGoTo({
      pathname: `/shop/productDetail/${id}`,
      search: type
        ? `type=${type}&preView=2&applyType=${applyType}&fromSource=${fromSource}`
        : `preView=2&applyType=${applyType}&fromSource=${fromSource}`,
      state: {
        card,
        item: newItem
      }
    });
  };

  setType = (value) => {
    const {
      orderCondition,
      id,
      type,
      maxAmount,
      minAmount,
      bv,
      bvMode,
      minItemNum,
      maxItemNum,
      itemPriceType,
      supplementInfo
    } = value || {};
    const card = {
      orderCondition,
      id: id || '',
      type,
      maxAmount: maxAmount || 0,
      minAmount: minAmount || 0,
      bv,
      bvMode,
      minItemNum: minItemNum || 0,
      maxItemNum: maxItemNum || 0,
      itemPriceType,
      supplementInfo
    };
    return card;
  };

  /**
   * 橱窗（默认）
   */
  renderItemSquare() {
    const { data, applyType, res, fromSource } = this.props;
    return (
      <Flex className="product-list-item-content">
        {data.map((item) => {
          const { mediaRespDtoList } = item || {};
          const imgUrl = Util.getProductImgUrl(mediaRespDtoList);
          return (
            <Flex
              onClick={() => {
                this.goDetail(item, applyType, res, fromSource);
              }}
              direction="column"
              className="item-view">
              <ImgWrap className="item-viw-img" src={imgUrl} mode="full" w="230px" h="230px" />
              <Flex className="item-view-bottom ellipsis-two" justify="center">
                {item.name}
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    );
  }

  /**
   * 长条
   */
  renderItemBar() {
    return <div />;
  }

  render() {
    const { isList = false } = this.props;
    return (
      <Flex direction="column" className="common-product-item">
        {isList ? this.renderItemBar() : this.renderItemSquare()}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/ProductListTransverse/index.js